<template>
  <div class="step-success">
    <div class="step-success__icon">
      <i class="pi pi-check-circle" />
    </div>
    <h2 class="step-success__title">Agendamento confirmado!</h2>

    <div class="step-success__summary card mb-4">
      <div class="step-success__row">
        <i class="pi pi-briefcase mr-2" />
        <span>{{ service.name }}</span>
      </div>
      <div class="step-success__row">
        <i class="pi pi-calendar mr-2" />
        <span>{{ formattedDate }} às {{ formattedTime }}</span>
      </div>
      <div v-if="modalityLabel" class="step-success__row">
        <i class="pi pi-video mr-2" />
        <span>{{ modalityLabel }}</span>
      </div>
    </div>

    <template v-if="paymentMethod === 'stripe' && stripePaymentUrl">
      <div
        class="
          step-success__payment-info step-success__payment-info--stripe
          mb-3
        "
      >
        <i class="pi pi-info-circle mr-2" />
        O pagamento é necessário para confirmar o agendamento.
      </div>
      <Button
        label="Pagar Agora"
        icon="pi pi-credit-card"
        class="p-button-primary w-full mb-3"
        @click="openStripe"
      />
    </template>

    <template v-else>
      <div class="step-success__payment-info mb-3">
        <i class="pi pi-info-circle mr-2" />
        Iremos contactá-lo em breve com informações sobre o pagamento.
      </div>
    </template>

    <Button
      v-if="!isFromActivation"
      label="Ver os meus agendamentos"
      icon="pi pi-calendar"
      class="p-button-outlined w-full"
      @click="$router.push({ name: 'appointments' })"
    />
  </div>
</template>

<script>
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export default {
  name: "AppointmentStepSuccess",
  props: {
    service: { type: Object, required: true },
    dateTime: { type: Object, required: true },
    appointmentMode: { type: String, default: null },
    paymentMethod: { type: String, default: null },
    /** URL Stripe devolvida pelo POST do agendamento (prioritária sobre paymentUrl do serviço). */
    paymentLink: { type: String, default: null },
    isFromActivation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    stripePaymentUrl() {
      const fromApi = this.paymentLink && String(this.paymentLink).trim();
      if (fromApi) return fromApi;
      const legacy =
        this.service &&
        this.service.paymentUrl &&
        String(this.service.paymentUrl).trim();
      return legacy || "";
    },
    formattedDate() {
      return this.dateTime && this.dateTime.date
        ? dayjs(this.dateTime.date).format("DD/MM/YYYY")
        : "";
    },
    formattedTime() {
      if (!this.dateTime || !this.dateTime.time) return "";
      return this.dateTime.time;
    },
    modalityLabel() {
      const mode = this.appointmentMode;
      if (mode === "online") return "Consulta online";
      if (mode === "on-site") return "Consulta presencial";
      return "";
    },
  },
  methods: {
    openStripe() {
      const url = this.stripePaymentUrl;
      if (url) window.open(url, "_blank");
    },
  },
};
</script>
